import React, { useState,useEffect } from 'react';
import { useOrders } from './vanuser.hooks';
import { constants } from '../../constants';
import {
  Paper, TableContainer, Typography, Pagination,
  CircularProgress, Box, Stack, Divider, Button,
  Tooltip
} from '@mui/material';
import { useSelector,useDispatch } from 'react-redux';
import { showAlert } from '../../store/slices/alertSlice';
import VanOrderDetailsPopup from './VanOrderDetailsPopup';
import QrcodeGenerate from './QrcodeGenerate';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import '../../App.css'; 
import VisibilityRoundedIcon from '@mui/icons-material/VisibilityRounded';
import QrCodeIcon from '@mui/icons-material/QrCode';

import { useFetchTodaysLoad } from './vanuser.hooks';
import { setLoadSuccess,setLoadFailure } from '../../store/slices/loadSlice';
import {convertGMTToLocal} from '../../common';
export default function ManageVanOrders() {
  const perPage = constants.PERPAGE;
  const dispatch = useDispatch();
  const {
    data: loadData,
    isLoading: isLoadLoading,
    isError:isLoadLoadingError,
    error:loadLoadingError,
  } = useFetchTodaysLoad();

  useEffect(() => {
    if (loadData) {
      dispatch(setLoadSuccess(loadData));
    } else if (isLoadLoadingError) {
      dispatch(
        showAlert({
          severity: 'error',
          title: loadLoadingError?.message || "Error fetching today's load.",
        })
      );
      dispatch(setLoadFailure(loadLoadingError?.message || 'Failed to load data'));
    }
  }, [loadData, isLoadLoadingError, loadLoadingError, dispatch]);
  


  const [page, setPage] = useState(1);
  const [openPopup, setOpenPopup] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [openPopupQr, setOpenPopupQr] = useState(false);
  const [selectedQrcodeId, setSelectedQrcodeId] = useState(null);

  const popupOpen = (id) => {
    setOpenPopup(true);
    setSelectedId(id);
  };
  const popupClose = () => {
    setOpenPopup(false);
    setSelectedId(null);
  };
  const popupOpenQr = (id) => {
    setOpenPopupQr(true);
    setSelectedQrcodeId(id);
  };
  const popupCloseQr = () => {
    setOpenPopupQr(false);
    setSelectedQrcodeId(null);
  };
  const {
    data: orderData,
    isLoading,
    isError:isorderDataError,
    error:orderDataError
  } = useOrders({ page, perPage });


  useEffect(() => {
    if (isorderDataError && orderDataError) {
      dispatch(
        showAlert({
          severity: 'error',
          title: orderDataError.message || 'Error fetching orders.',
        })
      );
    }
  }, [isorderDataError, orderDataError, dispatch]);


  if (isLoading) {
    return (
      <Box textAlign="center" mt={4}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Paper sx={{ p: 3, mt: 4 }}>
      <Typography variant="h5" gutterBottom>
        Manage Orders
      </Typography>

      {/* Filters (you can add date/customer filter again if needed) */}
      <Box sx={{ my: 2 }}>
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
        


          {/* Add filters if needed */}
        </Stack>
      </Box>

      <Divider sx={{ my: 2 }} />

      {/* Orders Table */}
      <Table className="van-orders-table">
        <Thead>
          <Tr>
            <Th>ID</Th>
            <Th>Date</Th>
            <Th>Order Price</Th>
            <Th>Coupon Savings</Th>
            <Th>Discount</Th>
            <Th>Payment Mode</Th>
            <Th>Payment Status</Th>
            <Th>Customer</Th>
            <Th>Action</Th>
          </Tr>
        </Thead>
        <Tbody>
          {orderData?.orders?.data?.length !== 0 ? (
            orderData?.orders?.data?.map((order) => (
            <Tr key={order.id}>
              <Td>{order.id}</Td>
              <Td>{convertGMTToLocal(order.created_at)}</Td>
              <Td>€ {order.orderprice}</Td>
              <Td>
  {order.coupon_discount_amount && order.coupon_code
    ? `€ ${order.coupon_discount_amount} [${order.coupon_code}]`
    : 'N/A'}
</Td>
              <Td>€ {order.discountamount}</Td>
              <Td>
              {(constants.PAYMENT_MODE.CASH == order.paymentmode)?'Cash':
      (constants.PAYMENT_MODE.BANKTRANSFER == order.paymentmode)?'Bank Transfer':
      (constants.PAYMENT_MODE.CARD == order.paymentmode)?'Card':
      (constants.PAYMENT_MODE.PAYPAL == order.paymentmode)?'Paypal':'-NA-'}
      </Td>
      <Td>
      {(constants.PAYMENT_STATUS.PAID == order.paymentstatus)?'Paid':'Pending'}
      </Td>
              <Td>
                  {order.customername} <br />
                  {order.customerphonenumber}
              </Td>
              <Td>
                <div className='van-order-buttons'>
<Tooltip title="View Order Details">
                  <Button
                    size="small"
                    color="primary"
                    onClick={() => popupOpen(order.id)}
                    sx={{ ml: 1 }}
                  >
                    <VisibilityRoundedIcon />
                  </Button>
                  <Button
                    size="small"
                    color="secondary"
                    onClick={() => popupOpenQr(order.id)}
                    sx={{ ml: 1 }}
                  >
                    <QrCodeIcon />
                  </Button>
                  </Tooltip>


                </div>
              </Td>
            </Tr>
            ))
          ) :           
            <Tr>
                <Td colSpan={5} align="center">
                  <Typography variant="body1" color="textSecondary" align='center'>
                    No records found.
                  </Typography>
                </Td>
            </Tr>            
          }
        </Tbody>
        </Table>

      {orderData?.data?.length > 0 && (
      <Box mt={3} display="flex" justifyContent="center">
        <Pagination
          count={orderData?.orders?.last_page || 1}
          page={page}
          onChange={(e, value) => setPage(value)}
          color="primary"
        />
      </Box>
      )} 
      {selectedId && (
        <VanOrderDetailsPopup orderid={selectedId} open={openPopup} onClose={popupClose} />
      )}
           {selectedQrcodeId && (
        <QrcodeGenerate orderid={selectedQrcodeId} open={openPopupQr} onClose={popupCloseQr} />
      )}
    </Paper>
  );
}
